function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", {
  type: "text/css"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M632.9445481249999 563.0638296875c93.6399515625-45.19016625 158.557160625-140.798589375 158.557160625-251.56212093749997C791.50170875 157.38948312500003 666.112225625 32 511.97883406249997 32 357.88777437499994 32 232.5194571875 157.38948312500003 232.5194571875 311.50170875000003c0 110.7211996875 64.9172090625 206.37195468750002 158.53599468749997 251.56212093749997C216.09436625 615.2812259375 88.10142218750008 777.4578321875 88.10142218750008 969.1403375c0 12.6151471875 10.223349374999998 22.8596625 22.8596625 22.8596625h802.1201634375a22.8596625 22.8596625 0 0 0 22.8596625-22.8596625c-0.0211659375-191.682504375-128.03527687500002-353.85911156249995-302.99636250000003-406.0765078125z"
});

var SvgHead = function SvgHead(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    t: 1587466104363,
    className: "icon",
    viewBox: "0 0 1024 1024",
    width: 200,
    height: 200,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHead, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/head.decddbad.svg";
export { ForwardRef as ReactComponent };